import type { IconButtonStyles } from '../../ThemeTypes';
import colors from '../colors';
import fonts from '../fonts';

/**
 * Icon button styles for the Loop theme
 * TypeScript representation of _icon-button.scss
 */
export const iconButton: IconButtonStyles = {
  iconButton: {
    textAlign: 'left',
    padding: '17px 20px',
    borderRadius: '4px',
    border: `solid 1px ${colors.light}`,
    background: 'none',
    color: colors.dark,
    width: '100%',
    marginBottom: '15px',
    textDecoration: 'none',
    fontWeight: fonts.fontWeights.bold,
    textWrap: 'none',
    svgHolder: { width: '48px' },
    '&:hover, &.active': {
      background: 'none',
      borderColor: colors.primary,
      color: colors.primary,
      svg: {
        path: {
          fill: 'none',
          stroke: colors.primary,
        },
        use: {
          fill: colors.primary,
        },
      },
    },
    '&.active': {
      borderWidth: '2px',
    },
  },
};

export default iconButton;
